import { Deserializable } from '../protocols/deserializable';
import { AnnuityType } from '../annuities/dto/annuity-type';
import { AnnuityPensionAnnuityTypeIdEnum } from '../enum/shared/annuity-pension-annuity-type-id.enum';
import { AnnuityGuaranteePeriodType } from '../shared/annuity-guarantee-period-type';
import { AnnuityGuaranteePeriodTypeId } from '../annuities/enum/annuity-guarantee-period-type';
import { AnnuityAccountStateTypeEnum } from './enum/annuity-account-state-type.enum';
import { AnnuityPayeeDesignationEnum } from './enum/annuity-payee-designation.enum';
import { AnnuityBenefitSchedulePhase } from './annuity-benefit-schedule-phase';
import { AnnuityPensionAccountPaymentInstructionStatusEnum } from './enum/annuity-pension-account-payment-instruction-status.enum';
import { AnnuityDispositionDisplayEnum } from './enum/annuity-disposition-display.enum';
import { PaymentMethodTypeEnum } from '../enum/shared/payment-method-type-enum';
import { PaymentMethodType } from '../types/dto/payment-method-type';
import { BankAccount } from '../../views/banking/models/bank-account';

export class AnnuityEntitlement implements Deserializable {
  public paymentInstructionId!: string;
  public accountId!: number;
  public accountOwnerMemberId!: number | null;
  public continuationFromName!: string;
  public continuationFromMemberId!: number | null;
  public annuityTypeId!: AnnuityPensionAnnuityTypeIdEnum;
  public annuityType!: AnnuityType;
  public annuityGuaranteePeriodId!: AnnuityGuaranteePeriodTypeId;
  public annuityGuaranteePeriod!: AnnuityGuaranteePeriodType;
  public guaranteeEndDate!: string | null;
  public stateId!: AnnuityAccountStateTypeEnum;
  public payeeDesignationId!: AnnuityPayeeDesignationEnum;
  public allocationPercentage!: number;
  public paymentAmount!: number;
  public monthlyAmount!: number | null;
  public benefitSchedule!: AnnuityBenefitSchedulePhase[];
  public statusId!: AnnuityPensionAccountPaymentInstructionStatusEnum;
  public dispositionDisplay!: AnnuityDispositionDisplayEnum | null;
  public commutedValue!: number | null;
  public startDate!: string;
  public endDate!: string | null;
  public splitEffectiveDate!: string | null;
  public paymentMethodId!: PaymentMethodTypeEnum | null;
  public paymentMethod!: PaymentMethodType | null;
  public bankAccountId!: number | null;
  public bankAccount!: BankAccount | null;

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;
    if (this.annuityType) this.annuityType = Deserialize.instanceOf(AnnuityType, this.annuityType);
    if (this.annuityGuaranteePeriod) {
      this.annuityGuaranteePeriod = Deserialize.instanceOf(AnnuityGuaranteePeriodType, this.annuityGuaranteePeriod);
    }
    if (this.paymentMethod) this.paymentMethod = Deserialize.instanceOf(PaymentMethodType, this.paymentMethod);
    if (this.bankAccount) this.bankAccount = Deserialize.instanceOf(BankAccount, this.bankAccount);
  }
}
